import { render } from "./NewspaperVariantOutline.vue?vue&type=template&id=34295e5f"
import script from "./NewspaperVariantOutline.vue?vue&type=script&lang=js"
export * from "./NewspaperVariantOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__